// Port of api/fuel/app/classes/filter/search/users/sorts/query/hindex.php
import { sorted, sortReverse, sortPriority } from 'offline/filter/core/search/unit'
export default {
	name: 'hindex',
	post: false,
	require: function(config, filter) { return sorted('hindex', filter) > 0 },
	run: function(config, filter, data, query) {
		query.order('u.user_hindex', sortReverse('hindex', filter), sortPriority('hindex', filter))
	}
}
